import React, { Fragment } from "react";
import { Text, View, Image, StyleSheet, Svg, Path, Line, G, Rect, Defs, ClipPath } from "@react-pdf/renderer";

//import { TableRows } from "./TableRows";

import { cleanRackingName, removePercent } from "../Redux";

import {
  Table,
  TableTitle,
  TableRow,
  TableHeader,
  TableText,
  PerfTable,
  PerfRow,
  PerfCol,
  PerfColSmall,
  PerfCellHeader,
  PerfCell,
  SoilingColHeader,
  SoilingCellHeader,
  SoilingCell,
  BlankCell,
  LossTableBox,
  LossTableRow,
  LossTableTwoRow,
  LossTableHeader,
  LossTableHeaderSmall,
  LossTableCell,
  LossTableCellSmall,
  LossTableSpacingRow,
  LossTableSpacingRow_no_border,
  LossTableBifacialColSpan,
  BifacialHeader,
  BifacialSpacingRow,
  BifacialLossTableBox,
} from "./";

const months = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];

const DividerLineStyles = StyleSheet.create({
  line: {
    width: "100%",
    height: 1,
    backgroundColor: "#333",
    marginVertical: 10,
  },
});

//const DividerLine = () => <View style={DividerLineStyles.line}></View>;

const RundownStyles = StyleSheet.create({
  rundown_container: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    padding: 5,
    // height: 500,
  },
  header_text: {
    paddingLeft: 5,
    paddingBottom: 5,
    fontSize: 12,
  },
  header_text_map: {
    paddingBottom: 5,
    fontSize: 12,
  },
  rundown_column: {
    maxWidth: "50%",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    marginHorizontal: 3,
  },
  rundown_column_boxes: {
    maxWidth: "50%",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    marginHorizontal: 3,
  },
  info_box_column: {
    display: "flex",
    flexDirection: "column",
  },
  info_box_row: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-evenly",
    marginBottom: 3,
  },
  info_box: {
    height: 70,
    width: 80,
    padding: 5,
    display: "flex",
    marginHorizontal: 3,
    flexDirection: "column",
    justifyContent: "start",
    borderTopColor: "#333",
    borderTopWidth: 1,
    borderLeftColor: "#333",
    borderLeftWidth: 1,
    borderRightColor: "#333",
    borderRightWidth: 1,
    borderBottomWidth: 1,
    borderBottomColor: "#333",
    borderTopLeftRadius: 2,
    borderTopRightRadius: 2,
    borderBottomLeftRadius: 2,
    borderBottomRightRadius: 2,
  },
  box_text_light: {
    fontSize: 8,
    opacity: 0.8,
    marginVertical: 3,
  },
  box_text_bold: {
    fontSize: 8,
    width: 80,
    display: "flex",
    flexDirection: "row",
  },
  location_map: {
    // height: "auto",
    // width: "100%",
  },
});

const Rundown = ({ reportData }) => (
  <View style={RundownStyles.rundown_container}>
    <View style={RundownStyles.rundown_column_boxes}>
      <Text style={RundownStyles.header_text}>Report Rundown</Text>
      <View style={RundownStyles.info_box_column}>
        <View style={RundownStyles.info_box_row}>
          {/* <View style={RundownStyles.info_box}>
            <Svg width="14" height="20" viewBox="0 0 14 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <Path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11 13.915V16C11 18.2091 9.20914 20 7 20C4.79086 20 3 18.2091 3 16V13.915C3 13.7197 2.93083 13.5067 2.76746 13.2262C2.6625 13.046 2.52518 12.848 2.318 12.5739L2.24831 12.483C2.10998 12.3027 1.80784 11.9089 1.6963 11.7583C0.566442 10.2322 0 8.86987 0 7C0 3.13401 3.13401 0 7 0C10.866 0 14 3.13401 14 7C14 8.91076 13.4258 10.3248 12.3056 11.848C12.1868 12.0094 11.8873 12.3987 11.7099 12.6292L11.7099 12.6292C11.6405 12.7195 11.5898 12.7854 11.5759 12.8039C11.3495 13.105 11.2089 13.3185 11.1175 13.5039C11.0347 13.6717 11 13.8013 11 13.915ZM9.04369 13.4393C9.0947 13.1627 9.18955 12.8913 9.32384 12.6191C9.4817 12.2991 9.68243 11.9943 9.97716 11.6022C9.99736 11.5753 10.0624 11.4908 10.1463 11.3816L10.1468 11.3809C10.3269 11.1468 10.594 10.7996 10.6944 10.663C11.583 9.45479 12 8.42791 12 7C12 4.23858 9.76142 2 7 2C4.23858 2 2 4.23858 2 7C2 8.37855 2.40666 9.35662 3.3037 10.5682C3.39996 10.6982 3.67174 11.0526 3.81868 11.2442L3.81889 11.2444L3.91348 11.3679C4.16474 11.7003 4.3425 11.9566 4.49567 12.2196C4.73422 12.6291 4.89259 13.0283 4.9612 13.4423C5.58435 13.8163 6.25799 14 7 14C7.74395 14 8.41917 13.8153 9.04369 13.4393ZM9 16V15.6624C8.36753 15.8869 7.69934 16 7 16C6.30066 16 5.63247 15.8869 5 15.6624V16C5 17.1046 5.89543 18 7 18C8.10457 18 9 17.1046 9 16Z"
                fill={reportData.platform === "internal_sift" ? "#60de4f" : "#002bcb"}
              />
            </Svg>
            <Text style={RundownStyles.box_text_light}>Module Rating</Text>
            <Text style={RundownStyles.box_text_bold}>{`${reportData.mod_rating} W`}</Text>
          </View> */}
          <View style={RundownStyles.info_box}>
            <Svg width="30" height="15" viewBox="0 0 30 15" fill="none" xmlns="http://www.w3.org/2000/Svg">
              <Path
                d="M8.20422 12.8755H3.20777C3.05804 12.8755 2.91495 12.9373 2.81232 13.0463C2.48604 13.3929 2.73177 13.9617 3.20777 13.9617H8.20422C8.66367 13.9617 8.91556 13.4268 8.62287 13.0726C8.51969 12.9478 8.36618 12.8755 8.20422 12.8755Z"
                fill={reportData.platform === "internal_sift" ? "#60de4f" : "#002bcb"}
              />
              <Path
                d="M2.81232 13.0463L2.44826 12.7036L2.44826 12.7036L2.81232 13.0463ZM8.62287 13.0726L9.00828 12.7541L9.00828 12.7541L8.62287 13.0726ZM3.20777 13.3755H8.20422V12.3755H3.20777V13.3755ZM8.20422 13.4617H3.20777V14.4617H8.20422V13.4617ZM3.20777 13.4617C3.19173 13.4617 3.18616 13.4579 3.18382 13.4563C3.17936 13.4532 3.17288 13.4466 3.16819 13.4357C3.16349 13.4249 3.16311 13.4156 3.16392 13.4102C3.16434 13.4074 3.16538 13.4007 3.17638 13.3891L2.44826 12.7036C1.8216 13.3693 2.29355 14.4617 3.20777 14.4617V13.4617ZM8.23746 13.3912C8.24691 13.4026 8.24787 13.4092 8.24821 13.4125C8.24879 13.4181 8.24797 13.4269 8.24323 13.437C8.2385 13.447 8.23219 13.4533 8.22755 13.4564C8.22478 13.4582 8.21906 13.4617 8.20422 13.4617V14.4617C9.08664 14.4617 9.57042 13.4343 9.00828 12.7541L8.23746 13.3912ZM8.20422 13.3755C8.21708 13.3755 8.22927 13.3812 8.23746 13.3912L9.00828 12.7541C8.81012 12.5143 8.51529 12.3755 8.20422 12.3755V13.3755ZM3.20777 12.3755C2.92019 12.3755 2.64538 12.4942 2.44826 12.7036L3.17638 13.3891C3.18452 13.3804 3.19588 13.3755 3.20777 13.3755V12.3755Z"
                fill={reportData.platform === "internal_sift" ? "#60de4f" : "#002bcb"}
              />
              <Path
                d="M1.48036 9.03915L6.66541 4.42181L9.30621 2.02341C9.50914 1.83911 9.50721 1.51584 9.30201 1.31814C9.11643 1.13934 8.82972 1.12799 8.64383 1.29207L0.76742 8.24479C0.528998 8.45525 0.545989 8.83676 0.803033 9.04441C1.00613 9.20849 1.29271 9.20626 1.48036 9.03915Z"
                fill={reportData.platform === "internal_sift" ? "#60de4f" : "#002bcb"}
                stroke={reportData.platform === "internal_sift" ? "#60de4f" : "#002bcb"}
              />
              <Path d="M5.62073 12.3972V4.51468" stroke={reportData.platform === "internal_sift" ? "#60de4f" : "#002bcb"} strokeWidth="2" />
              <Path
                d="M18.208 12.8755H13.2116C13.0618 12.8755 12.9187 12.9373 12.8161 13.0463C12.4898 13.3929 12.7355 13.9617 13.2116 13.9617H18.208C18.6675 13.9617 18.9193 13.4268 18.6267 13.0726C18.5235 12.9478 18.37 12.8755 18.208 12.8755Z"
                fill={reportData.platform === "internal_sift" ? "#60de4f" : "#002bcb"}
              />
              <Path
                d="M12.8161 13.0463L12.452 12.7036L12.452 12.7036L12.8161 13.0463ZM18.6267 13.0726L19.0121 12.7541L19.0121 12.7541L18.6267 13.0726ZM13.2116 13.3755H18.208V12.3755H13.2116V13.3755ZM18.208 13.4617H13.2116V14.4617H18.208V13.4617ZM13.2116 13.4617C13.1955 13.4617 13.1899 13.4579 13.1876 13.4563C13.1831 13.4532 13.1767 13.4466 13.172 13.4357C13.1673 13.4249 13.1669 13.4156 13.1677 13.4102C13.1681 13.4074 13.1692 13.4007 13.1802 13.3891L12.452 12.7036C11.8254 13.3693 12.2973 14.4617 13.2116 14.4617V13.4617ZM18.2412 13.3912C18.2507 13.4026 18.2517 13.4092 18.252 13.4125C18.2526 13.4181 18.2518 13.4269 18.247 13.437C18.2423 13.447 18.236 13.4533 18.2313 13.4564C18.2286 13.4582 18.2228 13.4617 18.208 13.4617V14.4617C19.0904 14.4617 19.5742 13.4343 19.0121 12.7541L18.2412 13.3912ZM18.208 13.3755C18.2209 13.3755 18.2331 13.3812 18.2412 13.3912L19.0121 12.7541C18.8139 12.5143 18.5191 12.3755 18.208 12.3755V13.3755ZM13.2116 12.3755C12.924 12.3755 12.6492 12.4942 12.452 12.7036L13.1802 13.3891C13.1883 13.3804 13.1997 13.3755 13.2116 13.3755V12.3755Z"
                fill={reportData.platform === "internal_sift" ? "#60de4f" : "#002bcb"}
              />
              <Path
                d="M11.4841 9.03915L16.6692 4.42181L19.31 2.02341C19.5129 1.83911 19.511 1.51584 19.3058 1.31814C19.1202 1.13934 18.8335 1.12799 18.6476 1.29207L10.7712 8.24479C10.5328 8.45525 10.5498 8.83676 10.8068 9.04441C11.0099 9.20849 11.2965 9.20626 11.4841 9.03915Z"
                fill={reportData.platform === "internal_sift" ? "#60de4f" : "#002bcb"}
                stroke={reportData.platform === "internal_sift" ? "#60de4f" : "#002bcb"}
              />
              <Path d="M15.6245 12.3972V4.51468" stroke={reportData.platform === "internal_sift" ? "#60de4f" : "#002bcb"} strokeWidth="2" />
              <Path
                d="M28.2118 12.8755H23.2153C23.0656 12.8755 22.9225 12.9373 22.8199 13.0463C22.4936 13.3929 22.7393 13.9617 23.2153 13.9617H28.2118C28.6712 13.9617 28.9231 13.4268 28.6304 13.0726C28.5273 12.9478 28.3738 12.8755 28.2118 12.8755Z"
                fill={reportData.platform === "internal_sift" ? "#60de4f" : "#002bcb"}
              />
              <Path
                d="M22.8199 13.0463L22.4558 12.7036L22.4558 12.7036L22.8199 13.0463ZM28.6304 13.0726L29.0158 12.7541L29.0158 12.7541L28.6304 13.0726ZM23.2153 13.3755H28.2118V12.3755H23.2153V13.3755ZM28.2118 13.4617H23.2153V14.4617H28.2118V13.4617ZM23.2153 13.4617C23.1993 13.4617 23.1937 13.4579 23.1914 13.4563C23.1869 13.4532 23.1805 13.4466 23.1758 13.4357C23.1711 13.4249 23.1707 13.4156 23.1715 13.4102C23.1719 13.4074 23.1729 13.4007 23.1839 13.3891L22.4558 12.7036C21.8292 13.3693 22.3011 14.4617 23.2153 14.4617V13.4617ZM28.245 13.3912C28.2545 13.4026 28.2554 13.4092 28.2558 13.4125C28.2564 13.4181 28.2555 13.4269 28.2508 13.437C28.2461 13.447 28.2398 13.4533 28.2351 13.4564C28.2324 13.4582 28.2266 13.4617 28.2118 13.4617V14.4617C29.0942 14.4617 29.578 13.4343 29.0158 12.7541L28.245 13.3912ZM28.2118 13.3755C28.2247 13.3755 28.2368 13.3812 28.245 13.3912L29.0158 12.7541C28.8177 12.5143 28.5229 12.3755 28.2118 12.3755V13.3755ZM23.2153 12.3755C22.9278 12.3755 22.6529 12.4942 22.4558 12.7036L23.1839 13.3891C23.1921 13.3804 23.2035 13.3755 23.2153 13.3755V12.3755Z"
                fill={reportData.platform === "internal_sift" ? "#60de4f" : "#002bcb"}
              />
              <Path
                d="M21.4881 9.03915L26.6731 4.42181L29.3139 2.02341C29.5168 1.83911 29.5149 1.51584 29.3097 1.31814C29.1241 1.13934 28.8374 1.12799 28.6515 1.29207L20.7751 8.24479C20.5367 8.45525 20.5537 8.83676 20.8107 9.04441C21.0138 9.20849 21.3004 9.20626 21.4881 9.03915Z"
                fill={reportData.platform === "internal_sift" ? "#60de4f" : "#002bcb"}
                stroke={reportData.platform === "internal_sift" ? "#60de4f" : "#002bcb"}
              />
              <Path d="M25.6284 12.3972V4.51468" stroke={reportData.platform === "internal_sift" ? "#60de4f" : "#002bcb"} strokeWidth="2" />
            </Svg>
            <Text style={RundownStyles.box_text_light}>GCR</Text>
            <Text style={RundownStyles.box_text_bold}>{`${+reportData.gcr?.toFixed(2)}`}</Text>
          </View>
          <View style={RundownStyles.info_box}>
            <Svg width="18" height="22" viewBox="0 0 18 22" fill="none" xmlns="http://www.w3.org/2000/svg">
              <Path
                d="M10.2061 15.9941H6.33887L5.16699 22H3.07227L4.24414 15.9941H0.743164V13.9873H4.625L5.63574 8.80176H1.85645V6.76562H6.03125L7.23242 0.671875H9.32715L8.12598 6.76562H11.9932L13.1943 0.671875H15.3037L14.1025 6.76562H17.0908V8.80176H13.707L12.6963 13.9873H15.9922V15.9941H12.3154L11.1436 22H9.03418L10.2061 15.9941ZM6.71973 13.9873H10.5869L11.5977 8.80176H7.73047L6.71973 13.9873Z"
                fill={reportData.platform === "internal_sift" ? "#60de4f" : "#002bcb"}
              />
            </Svg>
            <Text style={RundownStyles.box_text_light}>Module Quantity</Text>
            <Text style={RundownStyles.box_text_bold}>{`${reportData.en_mod_target === 1 ? parseInt(reportData.mod_target) : parseInt(reportData.module_count)}`}</Text>
          </View>
          {/* <View style={RundownStyles.info_box}>
            <Svg width="17" height="22" viewBox="0 0 17 22" fill="none" xmlns="http://www.w3.org/2000/svg">
              <Path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0 13.8508H5.08063V21.7016L16.1612 7.85078H11.0806V0L0 13.8508ZM7.08062 11.8508H4.16125L9.08062 5.70156V9.85078H12L7.08062 16V11.8508Z"
                fill={reportData.platform === "internal_sift" ? "#60de4f" : "#002bcb"}
              />
            </Svg>
            <Text style={RundownStyles.box_text_light}>Yield</Text>
            <Text style={RundownStyles.box_text_bold}>{`${+reportData["y. Yield (kWh/kWp)"]?.toFixed(2)} kWh/kWp`}</Text>
          </View> */}
          {reportData.do_finance == 0 ? (
            <View style={RundownStyles.info_box}>
              <Svg width="27" height="17" viewBox="0 0 27 17" fill="none" xmlns="https://www.w3.org/2000/svg">
                <Path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M20.6169 1.7871C21.0516 1.4464 21.1278 0.817841 20.7871 0.383162C20.4464 -0.0515172 19.8179 -0.127707 19.3832 0.212987L0.883178 14.713C0.547484 14.9761 0.41562 15.4232 0.554794 15.8263C0.693967 16.2295 1.07354 16.5 1.50006 16.5H25.5001C26.0523 16.5 26.5001 16.0523 26.5001 15.5C26.5001 14.9478 26.0523 14.5 25.5001 14.5H13.8269C13.6032 12.439 12.8899 10.4631 11.7497 8.73713L20.6169 1.7871ZM12.8205 14.5H4.39698L10.9598 9.35621C11.9667 10.903 12.6044 12.6634 12.8205 14.5Z"
                  fill={reportData.platform === "internal_sift" ? "#60de4f" : "#002bcb"}
                />
              </Svg>
              <Text style={RundownStyles.box_text_light}>{`Inverter Quantity`}</Text>
              <Text style={RundownStyles.box_text_bold}>{`${reportData.inverter_qty}`}</Text>
            </View>
          ) : reportData.toggle_finance_type == 1 ? (
            <View style={RundownStyles.info_box}>
              <Svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/Svg">
                <G clipPath="url(#clip0_415_176)">
                  <Path
                    d="M10 0C4.47768 0 0 4.47768 0 10C0 15.5223 4.47768 20 10 20C15.5223 20 20 15.5223 20 10C20 4.47768 15.5223 0 10 0ZM10 18.3036C5.41518 18.3036 1.69643 14.5848 1.69643 10C1.69643 5.41518 5.41518 1.69643 10 1.69643C14.5848 1.69643 18.3036 5.41518 18.3036 10C18.3036 14.5848 14.5848 18.3036 10 18.3036ZM11.0647 9.48214L10.4978 9.35045V6.35268C11.346 6.46875 11.8705 7 11.9598 7.65179C11.971 7.74107 12.0469 7.8058 12.1362 7.8058H13.1384C13.2433 7.8058 13.3259 7.71429 13.317 7.60938C13.1808 6.21875 12.0357 5.32589 10.5067 5.17188V4.44196C10.5067 4.34375 10.4263 4.26339 10.3281 4.26339H9.70089C9.60268 4.26339 9.52232 4.34375 9.52232 4.44196V5.17857C7.94196 5.33259 6.70536 6.20536 6.70536 7.83482C6.70536 9.34375 7.81696 10.0714 8.98438 10.3504L9.53571 10.4911V13.6763C8.54911 13.5446 7.99554 13.0179 7.8817 12.308C7.8683 12.2232 7.79241 12.1607 7.70536 12.1607H6.67411C6.5692 12.1607 6.48661 12.25 6.49554 12.3549C6.59598 13.5826 7.52679 14.7121 9.51339 14.8571V15.558C9.51339 15.6563 9.59375 15.7366 9.69196 15.7366H10.3259C10.4241 15.7366 10.5045 15.6563 10.5045 15.5558L10.5 14.8482C12.2478 14.6942 13.4978 13.7589 13.4978 12.0804C13.4955 10.5313 12.5112 9.83929 11.0647 9.48214ZM9.53348 9.12054C9.40848 9.08482 9.30357 9.05134 9.19866 9.00893C8.4442 8.73661 8.09375 8.29687 8.09375 7.72991C8.09375 6.91964 8.70759 6.45759 9.53348 6.35268V9.12054ZM10.4978 13.683V10.6987C10.567 10.7187 10.6295 10.7344 10.6942 10.7478C11.75 11.0692 12.1049 11.5156 12.1049 12.2009C12.1049 13.0737 11.4487 13.5982 10.4978 13.683Z"
                    fill={reportData.platform === "internal_sift" ? "#60de4f" : "#002bcb"}
                  />
                </G>
                <Defs>
                  <ClipPath id="clip0_415_176">
                    <Rect width="20" height="20" fill="white" />
                  </ClipPath>
                </Defs>
              </Svg>
              <Text style={RundownStyles.box_text_light}>{`LCOE`}</Text>
              <Text style={RundownStyles.box_text_bold}>{`${reportData.lcoe.toFixed(2)} $/MWh`}</Text>
            </View>
          ) : (
            <View style={RundownStyles.info_box}>
              <Svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/Svg">
                <G clipPath="url(#clip0_415_176)">
                  <Path
                    d="M10 0C4.47768 0 0 4.47768 0 10C0 15.5223 4.47768 20 10 20C15.5223 20 20 15.5223 20 10C20 4.47768 15.5223 0 10 0ZM10 18.3036C5.41518 18.3036 1.69643 14.5848 1.69643 10C1.69643 5.41518 5.41518 1.69643 10 1.69643C14.5848 1.69643 18.3036 5.41518 18.3036 10C18.3036 14.5848 14.5848 18.3036 10 18.3036ZM11.0647 9.48214L10.4978 9.35045V6.35268C11.346 6.46875 11.8705 7 11.9598 7.65179C11.971 7.74107 12.0469 7.8058 12.1362 7.8058H13.1384C13.2433 7.8058 13.3259 7.71429 13.317 7.60938C13.1808 6.21875 12.0357 5.32589 10.5067 5.17188V4.44196C10.5067 4.34375 10.4263 4.26339 10.3281 4.26339H9.70089C9.60268 4.26339 9.52232 4.34375 9.52232 4.44196V5.17857C7.94196 5.33259 6.70536 6.20536 6.70536 7.83482C6.70536 9.34375 7.81696 10.0714 8.98438 10.3504L9.53571 10.4911V13.6763C8.54911 13.5446 7.99554 13.0179 7.8817 12.308C7.8683 12.2232 7.79241 12.1607 7.70536 12.1607H6.67411C6.5692 12.1607 6.48661 12.25 6.49554 12.3549C6.59598 13.5826 7.52679 14.7121 9.51339 14.8571V15.558C9.51339 15.6563 9.59375 15.7366 9.69196 15.7366H10.3259C10.4241 15.7366 10.5045 15.6563 10.5045 15.5558L10.5 14.8482C12.2478 14.6942 13.4978 13.7589 13.4978 12.0804C13.4955 10.5313 12.5112 9.83929 11.0647 9.48214ZM9.53348 9.12054C9.40848 9.08482 9.30357 9.05134 9.19866 9.00893C8.4442 8.73661 8.09375 8.29687 8.09375 7.72991C8.09375 6.91964 8.70759 6.45759 9.53348 6.35268V9.12054ZM10.4978 13.683V10.6987C10.567 10.7187 10.6295 10.7344 10.6942 10.7478C11.75 11.0692 12.1049 11.5156 12.1049 12.2009C12.1049 13.0737 11.4487 13.5982 10.4978 13.683Z"
                    fill={reportData.platform === "internal_sift" ? "#60de4f" : "#002bcb"}
                  />
                </G>
                <Defs>
                  <ClipPath id="clip0_415_176">
                    <Rect width="20" height="20" fill="white" />
                  </ClipPath>
                </Defs>
              </Svg>
              <Text style={RundownStyles.box_text_light}>{`IRR`}</Text>
              <Text style={RundownStyles.box_text_bold}>{`${reportData.irr * 100} %`}</Text>
            </View>
          )}
        </View>

        <View style={RundownStyles.info_box_row}>
          {/* <View style={RundownStyles.info_box}>
            <Svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <Path
                d="M20 2.33332V0.33332C20 0.329063 19.9977 0.325508 19.9976 0.321289C19.997 0.28168 19.9891 0.242539 19.9746 0.205703C19.9734 0.202656 19.9705 0.19957 19.9691 0.196602C19.9543 0.164102 19.9341 0.134258 19.9096 0.108242C19.9015 0.100156 19.893 0.0925 19.8842 0.0853125C19.8632 0.0668359 19.8398 0.0510937 19.8148 0.0385547C19.8045 0.0329687 19.7939 0.0279297 19.783 0.0235156C19.746 0.00867188 19.7066 0.000703125 19.6666 0H9C8.9116 3.90625e-05 8.82684 0.0351562 8.76434 0.0976562L0.0977734 8.76422C0.0709766 8.79195 0.04875 8.8248 0.0330859 8.86004C0.0177734 8.89824 0.00804687 8.93844 0.00414062 8.97941C0.00367187 8.9866 0 8.99269 0 9V11C0 11.1841 0.149219 11.3333 0.33332 11.3333H2.83332C3.66137 11.3342 4.33242 12.0053 4.33332 12.8333V13.1953L0.0977734 17.4309C0.035625 17.4937 0.000546875 17.5783 0 17.6667V19.6667C0 19.8508 0.149219 20 0.33332 20H11C11.045 20 11.0894 19.9909 11.1307 19.9731C11.1352 19.9712 11.1384 19.9671 11.1429 19.965C11.1782 19.9486 11.2105 19.9262 11.2382 19.8987L11.2414 19.8965L17.9023 12.9023L19.9023 10.9023C19.9648 10.8398 20 10.7551 20 10.6667V8.66668C20 8.66242 19.9977 8.65887 19.9976 8.65465C19.997 8.61504 19.9891 8.5759 19.9746 8.53906C19.9734 8.53602 19.9705 8.53293 19.9691 8.52996C19.9364 8.4618 19.8822 8.40629 19.8148 8.37191C19.8045 8.36629 19.7939 8.36129 19.7831 8.35684C19.746 8.34199 19.7066 8.33402 19.6667 8.33332H17.1667C17.1383 8.33519 17.1103 8.34086 17.0834 8.35016C17.0564 8.3409 17.0284 8.33523 17 8.33332C16.2225 8.33094 15.5762 7.73363 15.5127 6.95863L19.9021 2.56922C19.9644 2.50645 19.9995 2.42176 20 2.33332ZM9 0.67L18.862 0.66668L10.862 8.66668H1.13801L9 0.67ZM4.33332 14.138V15.8333C4.33242 16.6614 3.66137 17.3324 2.83332 17.3333H1.13801L4.33332 14.138ZM10.6667 19.3333H0.66668V18H2.83336C4.02941 17.9986 4.99863 17.0294 5.00004 15.8333V12.8333C4.99867 11.6373 4.02941 10.668 2.83336 10.6666H0.66668V9.33332H10.6667V10.6666H8.5C7.30395 10.668 6.33473 11.6373 6.33332 12.8333V15.8333C6.33469 17.0294 7.30395 17.9986 8.5 18H10.6667V19.3333ZM19.3333 10.5286L17.4251 12.4368L11.3333 18.8332V17.7999L17.9023 10.9023L19.3334 9.47137L19.3333 10.5286ZM17 9C17.0284 8.99813 17.0564 8.99246 17.0833 8.98316C17.1102 8.99242 17.1382 8.99809 17.1666 9H18.862L17.4251 10.4368L10.8571 17.3333H8.5C7.67195 17.3324 7.0009 16.6614 7 15.8333V12.8333C7.0009 12.0053 7.67195 11.3342 8.5 11.3333H11C11.0884 11.333 11.1731 11.2979 11.2358 11.2355L14.948 7.52336C15.2448 8.40453 16.0702 8.99848 17 9ZM19.3333 2.19531L14.9311 6.59754L11.3333 10.1953V9.13801L19.3333 1.13801V2.19531Z"
                fill={reportData.platform === "internal_sift" ? "#60de4f" : "#002bcb"}
              />
              <Path
                d="M8.46118 15.6735C8.3361 15.6216 8.19203 15.6504 8.09668 15.7466C8.03578 15.8105 8.00129 15.895 8 15.9833C8 16.1674 8.14926 16.3166 8.33332 16.3166C8.51743 16.3166 8.66665 16.1674 8.66665 15.9833C8.66747 15.8478 8.58625 15.7254 8.46118 15.6735Z"
                fill={reportData.platform === "internal_sift" ? "#60de4f" : "#002bcb"}
              />
              <Path
                d="M9.74535 14.2633C9.62961 14.2352 9.50766 14.2709 9.42543 14.3571L9.09211 14.7064C8.96555 14.8397 8.97074 15.0503 9.10375 15.1771C9.23676 15.304 9.44735 15.2993 9.57453 15.1667L9.90785 14.8174C9.99008 14.7312 10.0201 14.6077 9.98657 14.4934C9.95305 14.3791 9.8611 14.2914 9.74535 14.2633Z"
                fill={reportData.platform === "internal_sift" ? "#60de4f" : "#002bcb"}
              />
              <Path
                d="M10.7588 12.9603L10.4255 13.3096C10.2984 13.4428 10.3033 13.6538 10.4366 13.7809C10.5698 13.908 10.7808 13.9031 10.9079 13.7699L11.2412 13.4206C11.3684 13.2874 11.3634 13.0763 11.2302 12.9492C11.097 12.8221 10.8859 12.8271 10.7588 12.9603Z"
                fill={reportData.platform === "internal_sift" ? "#60de4f" : "#002bcb"}
              />
              <Path
                d="M12.0921 11.5635L11.7588 11.9128C11.6667 12.0093 11.641 12.1514 11.6935 12.2741C11.746 12.3968 11.8665 12.4763 12 12.4763C12.0911 12.4764 12.1783 12.4391 12.2412 12.373L12.5745 12.0238C12.7016 11.8905 12.6967 11.6795 12.5635 11.5524C12.4302 11.4253 12.2192 11.4303 12.0921 11.5635Z"
                fill={reportData.platform === "internal_sift" ? "#60de4f" : "#002bcb"}
              />
              <Path
                d="M13.7457 10.0722C13.6297 10.0441 13.5076 10.0801 13.4254 10.1667L13.0921 10.516C13 10.6125 12.9743 10.7546 13.0268 10.8773C13.0793 11 13.1999 11.0795 13.3333 11.0795C13.4244 11.0796 13.5117 11.0423 13.5745 10.9763L13.9078 10.6269C13.9904 10.5408 14.0207 10.4171 13.9872 10.3026C13.9537 10.1882 13.8616 10.1003 13.7457 10.0722Z"
                fill={reportData.platform === "internal_sift" ? "#60de4f" : "#002bcb"}
              />
              <Path
                d="M14.5388 9.04015C14.4137 9.09207 14.3325 9.21453 14.3333 9.34996C14.3317 9.43781 14.3667 9.52234 14.43 9.58335C14.4923 9.64699 14.5776 9.68296 14.6667 9.68328C14.7557 9.68296 14.841 9.64695 14.9033 9.58335C14.9665 9.5223 15.0015 9.43777 15 9.34996C14.9993 9.2616 14.9647 9.17687 14.9033 9.11328C14.808 9.01711 14.6639 8.9882 14.5388 9.04015Z"
                fill={reportData.platform === "internal_sift" ? "#60de4f" : "#002bcb"}
              />
            </Svg>

            <Text style={RundownStyles.box_text_light}>Racking Product</Text>
            <Text style={RundownStyles.box_text_bold}>{`${cleanRackingName(reportData.racking_name)}`}</Text>
          </View> */}
          {reportData.track_mode === 1 ? (
            <View style={RundownStyles.info_box}>
              <Svg width="27" height="17" viewBox="0 0 27 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                <Path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M20.6169 1.7871C21.0516 1.4464 21.1278 0.817841 20.7871 0.383162C20.4464 -0.0515172 19.8179 -0.127707 19.3832 0.212987L0.883178 14.713C0.547484 14.9761 0.41562 15.4232 0.554794 15.8263C0.693967 16.2295 1.07354 16.5 1.50006 16.5H25.5001C26.0523 16.5 26.5001 16.0523 26.5001 15.5C26.5001 14.9478 26.0523 14.5 25.5001 14.5H13.8269C13.6032 12.439 12.8899 10.4631 11.7497 8.73713L20.6169 1.7871ZM12.8205 14.5H4.39698L10.9598 9.35621C11.9667 10.903 12.6044 12.6634 12.8205 14.5Z"
                  fill={reportData.platform === "internal_sift" ? "#60de4f" : "#002bcb"}
                />
              </Svg>

              <Text style={RundownStyles.box_text_light}>{"Tracking Angle"}</Text>
              <Text style={RundownStyles.box_text_bold}>{`+/- ${reportData.rlim}°`}</Text>
            </View>
          ) : (
            <View style={RundownStyles.info_box}>
              <Svg width="27" height="17" viewBox="0 0 27 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                <Path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M20.6169 1.7871C21.0516 1.4464 21.1278 0.817841 20.7871 0.383162C20.4464 -0.0515172 19.8179 -0.127707 19.3832 0.212987L0.883178 14.713C0.547484 14.9761 0.41562 15.4232 0.554794 15.8263C0.693967 16.2295 1.07354 16.5 1.50006 16.5H25.5001C26.0523 16.5 26.5001 16.0523 26.5001 15.5C26.5001 14.9478 26.0523 14.5 25.5001 14.5H13.8269C13.6032 12.439 12.8899 10.4631 11.7497 8.73713L20.6169 1.7871ZM12.8205 14.5H4.39698L10.9598 9.35621C11.9667 10.903 12.6044 12.6634 12.8205 14.5Z"
                  fill={reportData.platform === "internal_sift" ? "#60de4f" : "#002bcb"}
                />
              </Svg>

              <Text style={RundownStyles.box_text_light}>{"Tilt Angle"}</Text>
              <Text style={RundownStyles.box_text_bold}>{`${reportData.tilt}°`}</Text>
            </View>
          )}
          <View style={RundownStyles.info_box}>
            <Svg width="17" height="22" viewBox="0 0 17 22" fill="none" xmlns="https://www.w3.org/2000/Svg">
              <Path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0 13.8508H5.08063V21.7016L16.1612 7.85078H11.0806V0L0 13.8508ZM7.08062 11.8508H4.16125L9.08062 5.70156V9.85078H12L7.08062 16V11.8508Z"
                fill={reportData.platform === "internal_sift" ? "#60de4f" : "#002bcb"}
              />
            </Svg>
            <Text style={RundownStyles.box_text_light}>Yield</Text>
            <Text style={RundownStyles.box_text_bold}>{`${+reportData["y. Yield (kWh/kWp)"]?.toFixed(2)} kWh/kWp`}</Text>
          </View>
          <View style={RundownStyles.info_box}>
            <Svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <Path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M4.63843 12.5523H7.78842V17.4198L14.6584 8.83218H11.5084V3.9646L4.63843 12.5523ZM9.0283 11.3124H7.21829L10.2683 7.49979V10.0724H12.0783L9.0283 13.8849V11.3124Z"
                fill={reportData.platform === "internal_sift" ? "#60de4f" : "#002bcb"}
              />
              <Path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M8.0004 4.99992H4.19359C5.55402 3.07865 7.60679 1.99997 10.0003 1.99997C14.4185 1.99997 18.0001 5.58163 18.0001 9.99984H20C20 4.47708 15.523 0 10.0003 0C7.1962 0 4.72562 1.18249 3.00057 3.2703V0H1.00063V6.99989H8.0004V4.99992ZM11.9996 15.0001H15.8064C14.446 16.9214 12.3932 18 9.99967 18C5.58154 18 1.99993 14.4184 1.99993 10.0002H0C0 15.5229 4.47701 20 9.99967 20C12.8038 20 15.2744 18.8175 16.9994 16.7297V20H18.9994V13.0001H11.9996V15.0001Z"
                fill={reportData.platform === "internal_sift" ? "#60de4f" : "#002bcb"}
              />
            </Svg>
            <Text style={RundownStyles.box_text_light}>Generation Yr 1</Text>
            <Text style={RundownStyles.box_text_bold}>{`${+reportData["fh. Energy injected into Grid (MWh)"]?.toFixed(2)} MWh`}</Text>
          </View>
        </View>

        <View style={RundownStyles.info_box_row}>
          {reportData.platform === "internal_sift" ? (
            <View style={RundownStyles.info_box}>
              <Svg width="22" height="12" viewBox="0 0 22 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <Path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M22 10V2C22 0.89543 21.1046 0 20 0H2C0.89543 0 0 0.89543 0 2V10C0 11.1046 0.89543 12 2 12H20C21.1046 12 22 11.1046 22 10ZM2 2H4V5H6V2H8V7H10V2H12V5H14V2H16V7H18V2H20V10H2V2Z"
                  fill={reportData.platform === "internal_sift" ? "#60de4f" : "#002bcb"}
                />
              </Svg>
              <Text style={RundownStyles.box_text_light}>Pitch</Text>
              <Text style={RundownStyles.box_text_bold}>{`${parseFloat(reportData.pitch)?.toFixed(2)} m`}</Text>
            </View>
          ) : (
            <View style={RundownStyles.info_box}>
              <Svg width="32" height="18" viewBox="0 0 32 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <Line x1="0" y1="5.06403" x2="2.94737" y2="5.06403" stroke={reportData.platform === "internal_sift" ? "#60de4f" : "#002bcb"} strokeWidth={2} />
                <Line x1="3.6842" y1="5.06403" x2="6.63157" y2="5.06403" stroke={reportData.platform === "internal_sift" ? "#60de4f" : "#002bcb"} strokeWidth={2} />
                <Line x1="11.0526" y1="5.06403" x2="14" y2="5.06403" stroke={reportData.platform === "internal_sift" ? "#60de4f" : "#002bcb"} strokeWidth={2} />
                <Line x1="7.36841" y1="5.06403" x2="10.3158" y2="5.06403" stroke={reportData.platform === "internal_sift" ? "#60de4f" : "#002bcb"} strokeWidth={2} />
                <Path d="M0 1.60803H14" stroke={reportData.platform === "internal_sift" ? "#60de4f" : "#002bcb"} strokeWidth={2} />
                <Path d="M18.7596 15.6879C22.4937 10.9702 26.9846 19.5704 31.234 14.692" stroke={reportData.platform === "internal_sift" ? "#60de4f" : "#002bcb"} strokeWidth={2} />
                <Path d="M18 11H32" stroke={reportData.platform === "internal_sift" ? "#60de4f" : "#002bcb"} strokeWidth={2} />
                <Path d="M24 1L6 17" stroke={reportData.platform === "internal_sift" ? "#60de4f" : "#002bcb"} strokeWidth={2} strokeLinecap="round" />
              </Svg>
              <Text style={RundownStyles.box_text_light}>DC:AC</Text>
              <Text style={RundownStyles.box_text_bold}>{`${+reportData.dcac?.toFixed(2)}`}</Text>
            </View>
          )}

          <View style={RundownStyles.info_box}>
            <Svg width="20" height="9" viewBox="0 0 20 9" fill="none" xmlns="http://www.w3.org/2000/Svg">
              <Path d="M0 6.93726H4.21052" stroke={reportData.platform === "internal_sift" ? "#60de4f" : "#002bcb"} strokeWidth="2" />
              <Path d="M5.26318 6.93726H9.47371" stroke={reportData.platform === "internal_sift" ? "#60de4f" : "#002bcb"} strokeWidth="2" />
              <Path d="M10.5262 6.93726H14.7368" stroke={reportData.platform === "internal_sift" ? "#60de4f" : "#002bcb"} strokeWidth="2" />
              <Path d="M15.7894 6.93726H20" stroke={reportData.platform === "internal_sift" ? "#60de4f" : "#002bcb"} strokeWidth="2" />
              <Path d="M0 2H20" stroke={reportData.platform === "internal_sift" ? "#60de4f" : "#002bcb"} strokeWidth="2" />
            </Svg>
            <Text style={RundownStyles.box_text_light}>DC Capacity</Text>
            <Text style={RundownStyles.box_text_bold}> {`${reportData.MWp} MWp`}</Text>
          </View>
          <View style={RundownStyles.info_box}>
            <Svg width="22" height="11" viewBox="0 0 22 11" fill="none" xmlns="http://www.w3.org/2000/Svg">
              <Path d="M2.08521 8.69706C7.41963 1.95749 13.8352 14.2435 19.9058 7.27435" stroke={reportData.platform === "internal_sift" ? "#60de4f" : "#002bcb"} strokeWidth="2" />
              <Path d="M1 2H21" stroke={reportData.platform === "internal_sift" ? "#60de4f" : "#002bcb"} strokeWidth="2" />
            </Svg>
            <Text style={RundownStyles.box_text_light}>AC Capacity</Text>
            <Text style={RundownStyles.box_text_bold}> {`${reportData.MWac} MWac`}</Text>
          </View>

          {/* <View style={RundownStyles.info_box}>
            <Svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
              <Path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M6.20654 21.1905L4.52209 16.6684L0 14.9839L2.00653 10.5952L0 6.20654L4.52209 4.52209L6.20654 0L10.5952 2.00651L14.9839 0L16.6684 4.52209L21.1905 6.20654L19.184 10.5952L21.1905 14.9839L16.6684 16.6684L14.9839 21.1905L10.5952 19.184L6.20654 21.1905ZM10.5952 16.9848L13.8602 18.4776L15.1133 15.1134L18.4776 13.8602L16.9849 10.5952L18.4776 7.33026L15.1133 6.0771L13.8602 2.71288L10.5952 4.20563L7.33026 2.71288L6.07709 6.0771L2.71289 7.33026L4.20563 10.5952L2.71289 13.8602L6.07709 15.1134L7.33026 18.4776L10.5952 16.9848ZM10.5 15C12.9853 15 15 12.9853 15 10.5C15 8.01472 12.9853 6 10.5 6C8.01471 6 6 8.01472 6 10.5C6 12.9853 8.01471 15 10.5 15ZM10.5 13.2C9.00885 13.2 7.79999 11.9912 7.79999 10.5C7.79999 9.00883 9.00885 7.8 10.5 7.8C11.9911 7.8 13.2 9.00883 13.2 10.5C13.2 11.9912 11.9911 13.2 10.5 13.2Z"
                fill={reportData.platform === "internal_sift" ? "#60de4f" : "#002bcb"}
              />
            </Svg>
            <Text style={RundownStyles.box_text_light}>Site Capacity</Text>
            <Text style={RundownStyles.box_text_bold}>{`${parseFloat(reportData.capacity / 1000)?.toFixed(2)} MWp`}</Text>
          </View> */}
        </View>
      </View>
    </View>
    <View style={RundownStyles.rundown_column}>
      <Text style={RundownStyles.header_text_map}>Vicinity Map</Text>
      {reportData.images.vicinityMap && <Image style={RundownStyles.location_map} src={reportData.images.vicinityMap} />}
    </View>
  </View>
);

// const GM_SiteOverview_Styles = StyleSheet.create({
//   overview_container: {
//     width: "100%",
//     height: "100%",
//     padding: 10,
//     display: "flex",
//     flexDirection: "column",
//     justifyContent: "center",
//     alignItems: "center",
//   },
//   map_image: {
//     width: "100%",
//     marginBottom: 10,
//   },
//   overview_row: {
//     width: "100%",
//     display: "flex",
//     flexDirection: "row",
//     alignItems: "center",
//     justifyContent: "space-between",
//   },
//   row_image: {
//     width: "50%",
//   },
// });

// const GM_Site_Overview = ({ reportData }) => {
//   return (
//     <View style={GM_SiteOverview_Styles.overview_container}>
//       <Info_Boxes />
//       <Image style={GM_SiteOverview_Styles.map_image} src={reportData.reportImages.locationMap} />
//       <DividerLine />
//       <View style={GM_SiteOverview_Styles.overview_row}>
//         <Table>
//           <TableTitle title="Site Overview" />
//           <TableRow>
//             <TableHeader>Type</TableHeader>
//             <TableText>{`${reportData.racking_name}`}</TableText>
//           </TableRow>
//           <TableRow>
//             <TableHeader>Module</TableHeader>
//             <TableText>{`${reportData.mod_name}`}</TableText>
//           </TableRow>
//           <TableRow>
//             <TableHeader>Rating</TableHeader>
//             <TableText>{`${reportData.mod_rating} W`}</TableText>
//           </TableRow>
//           <TableRow>
//             <TableHeader>Module Qty</TableHeader>
//             <TableText>{`${parseInt(reportData.module_count)}`}</TableText>
//           </TableRow>
//           <TableRow>
//             <TableHeader>Site Capacity</TableHeader>
//             <TableText>{`${reportData.capacity} kW`}</TableText>
//           </TableRow>
//           <TableRow>
//             <TableHeader>GCR</TableHeader>
//             <TableText>{`${reportData.gcr}`}</TableText>
//           </TableRow>
//           <TableRow>
//             <TableHeader>{`Pitch(m)`}</TableHeader>
//             <TableText>{`${reportData.pitch}`}</TableText>
//           </TableRow>
//           <TableRow>
//             <TableHeader>{`Intra-row Spacing (m)`}</TableHeader>
//             <TableText>{`${+reportData.r2r?.toFixed(2)}m`}</TableText>
//           </TableRow>
//           <TableRow>
//             <TableHeader>{`Azimuth°`}</TableHeader>
//             <TableText>{`${reportData.sazm}°`}</TableText>
//           </TableRow>
//           <TableRow>
//             <TableHeader>{`${reportData.racking_name === "Single Axis" ? "Tracker" : "Row"}`}</TableHeader>
//             <TableText>{`${reportData.table_a + reportData.table_b + reportData.table_c + reportData.table_d}`}</TableText>
//           </TableRow>
//           <TableRow>
//             <TableHeader>{`Tracking Angle`}</TableHeader>
//             <TableText>{`${reportData.selectedProduct.track_angle}°`}</TableText>
//           </TableRow>
//         </Table>
//       </View>
//     </View>
//   );
// };

const Module_styles = StyleSheet.create({
  module_section: {
    marginTop: 5,
    // width: '100%',
  },
  row: {
    flexDirection: "row",
  },
  column: {
    paddingHorizontal: 10,
    width: "50%",
    flexDirection: "column",
  },
  column_text: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: 5,
  },
  column_text_light: {
    color: "#444",
  },
});

const ModuleSection = ({ reportData }) => {
  return (
    <View style={Module_styles.module_section}>
      <Table>
        <TableTitle title="Module Inputs" />
        <TableRow>
          <TableHeader>Module Name</TableHeader>
          <TableText>{`${reportData.mod_name}`}</TableText>
        </TableRow>
        <TableRow>
          <TableHeader>Module Rating</TableHeader>
          <TableText>{`${reportData.mod_rating} W`}</TableText>
        </TableRow>
        <TableRow>
          <TableHeader>Module Width</TableHeader>
          <TableText>{`${reportData.mod_width} m`}</TableText>
        </TableRow>
        <TableRow>
          <TableHeader>Module Height</TableHeader>
          <TableText>{`${reportData.mod_height} m`}</TableText>
        </TableRow>
        <TableRow>
          <TableHeader>Module Area</TableHeader>
          <TableText>{`${reportData.mod_area?.toFixed(2)} m²`}</TableText>
        </TableRow>

        {reportData.simple_module === 0 && (
          <>
            <TableRow>
              <TableHeader>Technology</TableHeader>
              <TableText>{reportData.technology === 0 ? "Si-Mono" : reportData.technology === 1 ? "Si-Poly" : "CdTe"}</TableText>
            </TableRow>
            {reportData.en_bifacial === 1 && (
              <>
                <TableRow>
                  <TableHeader>Bifacial</TableHeader>
                  <TableText>{"True"}</TableText>
                </TableRow>
                <TableRow>
                  <TableHeader>Bifaciality Factor</TableHeader>
                  <TableText>{reportData.bi_bifaciality}</TableText>
                </TableRow>
              </>
            )}
            <TableRow>
              <TableHeader>Gref</TableHeader>
              <TableText>{`${reportData.mlm_S_ref} W/m²`}</TableText>
            </TableRow>
            <TableRow>
              <TableHeader>Tref</TableHeader>
              <TableText>{`${reportData.mlm_T_ref}° C`}</TableText>
            </TableRow>
            <TableRow>
              <TableHeader>Isc</TableHeader>
              <TableText>{`${reportData.mlm_I_sc_ref} A`}</TableText>
            </TableRow>
            <TableRow>
              <TableHeader>Voc</TableHeader>
              <TableText>{`${reportData.mlm_V_oc_ref} V`}</TableText>
            </TableRow>
            <TableRow>
              <TableHeader>Imp</TableHeader>
              <TableText>{`${reportData.mlm_I_mp_ref} A`}</TableText>
            </TableRow>
            <TableRow>
              <TableHeader>Vmp</TableHeader>
              <TableText>{`${reportData.mlm_V_mp_ref} V`}</TableText>
            </TableRow>
            <TableRow>
              <TableHeader>Tcoef of Isc</TableHeader>
              <TableText>{`${reportData.mlm_alpha_isc} mA/°C`}</TableText>
            </TableRow>
            <TableRow>
              <TableHeader>Tcoef of Voc</TableHeader>
              <TableText>{`${reportData.mlm_beta_voc_spec} mV/°C`}</TableText>
            </TableRow>
            <TableRow>
              <TableHeader>Cells In Series</TableHeader>
              <TableText>{`${reportData.mlm_N_series}`}</TableText>
            </TableRow>
            <TableRow>
              <TableHeader>Cells In Parallel</TableHeader>
              <TableText>{`${reportData.mlm_N_parallel}`}</TableText>
            </TableRow>
            <TableRow>
              <TableHeader>Rsh</TableHeader>
              <TableText>{`${reportData.mlm_R_shref} Ω`}</TableText>
            </TableRow>
            <TableRow>
              <TableHeader>Rshunt at G=0</TableHeader>
              <TableText>{`${reportData.mlm_R_sh0} Ω`}</TableText>
            </TableRow>
            <TableRow>
              <TableHeader>Rs</TableHeader>
              <TableText>{`${reportData.mlm_R_s} Ω`}</TableText>
            </TableRow>
            <TableRow>
              <TableHeader>Shunt Exp</TableHeader>
              <TableText>{`${reportData.mlm_R_shexp}`}</TableText>
            </TableRow>
            <TableRow>
              <TableHeader>Absorb Coef</TableHeader>
              <TableText>{`${reportData.mlm_T_c_fa_alpha}`}</TableText>
            </TableRow>
            <TableRow>
              <TableHeader>Tcoef of Pmpp</TableHeader>
              <TableText>{`${reportData.muPmpReq} %/°C`}</TableText>
            </TableRow>
            <TableRow>
              <TableHeader>Gamma</TableHeader>
              <TableText>{`${reportData.mlm_n_0}`}</TableText>
            </TableRow>
            <TableRow>
              <TableHeader>Tcoef of Gamma</TableHeader>
              <TableText>{`${reportData.mlm_mu_n} 1/°C`}</TableText>
            </TableRow>
          </>
        )}
      </Table>
    </View>
  );
};

const IAMTable_report = ({ reportData }) => (
  <Table>
    <TableTitle title="IAM Values" />
    {reportData.module_iam_ang.map((item, index) => {
      if (index > 24) return;
      return (
        <TableRow key={index}>
          <TableHeader>{`${item}`}</TableHeader>
          <TableText>{`${reportData.module_iam_eff[index]}`}</TableText>
        </TableRow>
      );
    })}
  </Table>
);

const Breakdown_Styles = StyleSheet.create({
  tracker_breakdown: {
    width: "100%",
    marginTop: 20,
    borderLeftColor: "#666",
    borderLeftWidth: 1,
    borderRightColor: "#666",
    borderRightWidth: 1,
    borderBottomColor: "#666",
    borderBottomWidth: 1,
    borderTopColor: "#666",
    borderTopWidth: 1,
  },
  section_title: {
    paddingBottom: 3,
    marginBottom: 8,
    color: "#444",
    fontSize: 14,
  },
  tracker_table: {
    width: "100%",
    justifyContent: "center",
    flexDirection: "row",
  },
  tracker_table_header: {
    width: "20%",
    borderBottomColor: "#666",
    borderBottomWidth: 1,
    backgroundColor: "#EAEAEA",
    borderRightColor: "#666",
    borderRightWidth: 1,
    paddingHorizontal: 3,
    paddingVertical: 2,
  },
  tracker_table_header_last: {
    width: "20%",
    borderBottomColor: "#666",
    borderBottomWidth: 1,
    backgroundColor: "#EAEAEA",
    paddingHorizontal: 3,
    paddingVertical: 2,
  },
  tracker_table_body_row: {
    width: "100%",
    flexDirection: "row",
    borderBottomColor: "#666",
    borderBottomWidth: 1,
  },
  tracker_table_body_text: {
    color: "#444",
    width: "20%",
    borderRightColor: "#666",
    borderRightWidth: 1,
    paddingHorizontal: 3,
    paddingVertical: 2,
  },
  tracker_table_body_text_last: {
    color: "#444",
    width: "20%",
    paddingHorizontal: 3,
    paddingVertical: 2,
  },
});

const Tracker_Breakdown = ({ reportData }) => {
  const letters = ["A", "B", "C"];
  const table_keys = ["table_a", "table_b", "table_c"];
  return (
    <View style={Breakdown_Styles.tracker_breakdown}>
      <View style={Breakdown_Styles.tracker_table}>
        <Text style={Breakdown_Styles.tracker_table_header}>Tracker Sizes</Text>
        <Text style={Breakdown_Styles.tracker_table_header}>Qty</Text>
        <Text style={Breakdown_Styles.tracker_table_header}>Module Count</Text>
        <Text style={Breakdown_Styles.tracker_table_header}>{`Tracker X`}</Text>
        <Text style={Breakdown_Styles.tracker_table_header_last}>{`Tracker Y`}</Text>
      </View>
      {Object.values(reportData.racks).map((rack, index) => (
        <View key={index} style={Breakdown_Styles.tracker_table_body_row}>
          <Text style={Breakdown_Styles.tracker_table_body_text}>{letters[index]}</Text>
          <Text style={Breakdown_Styles.tracker_table_body_text}>{reportData.rack_breakdown[index]}</Text>
          <Text style={Breakdown_Styles.tracker_table_body_text}>{reportData[table_keys[index]] === 0 ? "N/A" : `${rack.module}`}</Text>
          <Text style={Breakdown_Styles.tracker_table_body_text}>{reportData[table_keys[index]] === 0 ? "N/A" : `${rack.xdim?.toFixed(2)} m`}</Text>
          <Text style={Breakdown_Styles.tracker_table_body_text_last}>{reportData[table_keys[index]] === 0 ? "N/A" : `${rack.ydim?.toFixed(2)} m`}</Text>
        </View>
      ))}
    </View>
  );
};

const Racking = ({ reportData }) => {
  return (
    <View style={Module_styles.module_section}>
      <Table>
        <TableTitle title="Racking Inputs" />
        <TableRow>
          <TableHeader>Racking Product</TableHeader>
          <TableText>{`${cleanRackingName(reportData.racking_name)}`}</TableText>
        </TableRow>
        <TableRow>
          <TableHeader>Type</TableHeader>
          <TableText>{reportData.track_mode === 1 ? "Single Axis Tracker" : reportData.track_mode === 2 ? "East-West Fixed" : "Ground Fixed Tilt"}</TableText>
        </TableRow>
        {/* <TableRow>
          <TableHeader>Rack to Rack Gap</TableHeader>
          <TableText>{`${reportData.selectedProduct.gap}`}</TableText>
        </TableRow> */}
        <TableRow>
          <TableHeader>Grade Limit</TableHeader>
          <TableText>{`${reportData.rack_grade_limit} %`}</TableText>
        </TableRow>
        {reportData.track_mode === 1 && reportData.en_backtrack === 1 && (
          <TableRow>
            <TableHeader>Backtrack</TableHeader>
            <TableText>{"Yes"}</TableText>
          </TableRow>
        )}
        {reportData.track_mode === 1 ? (
          <TableRow>
            <TableHeader>Tracking Angle</TableHeader>
            <TableText>{`+/- ${reportData.rlim}°`}</TableText>
          </TableRow>
        ) : (
          <TableRow>
            <TableHeader>Tilt Angle</TableHeader>
            <TableText>{`${reportData.tilt}°`}</TableText>
          </TableRow>
        )}
        {/* {reportData.track_mode == 1 ? (
          <TableRow>
            <TableHeader>Tracking Angle</TableHeader>
            <TableText>{`+/- ${reportData.rlim}°`}</TableText>
          </TableRow>
        ) : reportData.track_mode == 2 ? (
          <TableRow>
            <TableHeader>Tilt Angle</TableHeader>
            <TableText>{`${reportData.tilt}°`}</TableText>
          </TableRow>
        ) : (
          <TableRow>
            <TableHeader>"Tilt Min/Max"</TableHeader>
            <TableText>{`${reportData.tilt_min}°/${reportData.tilt_max}°`}</TableText>
          </TableRow>
        )} */}

        <TableRow>
          <TableHeader>Height Above Ground</TableHeader>
          <TableText>{`${reportData.bi_groundClearanceHeight} m`}</TableText>
        </TableRow>

        {reportData.track_mode === 0 && (
          <Fragment>
            <TableRow>
              <TableHeader>String Steps</TableHeader>
              <TableText>{reportData.Fshd_StringSteps}</TableText>
            </TableRow>
            <TableRow>
              <TableHeader>Cell Transverse</TableHeader>
              <TableText>{`${reportData.Fshd_Celltrav} m`}</TableText>
            </TableRow>
          </Fragment>
        )}
        <TableRow>
          <TableHeader>Racking Dimension Mode</TableHeader>
          <TableText>{`${reportData.rack_dims === 0 ? "Auto" : "Manual"}`}</TableText>
        </TableRow>
      </Table>
    </View>
  );
};

const PerfStyles = StyleSheet.create({
  perf_container: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
});

const Performance = ({ reportData }) => {
  return (
    <View style={Module_styles.module_section}>
      <View style={PerfStyles.perf_container}>
        <Table>
          <TableTitle title="Performance Inputs" />
          <TableRow>
            <TableHeader>Modules Per String</TableHeader>
            <TableText>{`${reportData.mod_per_string}`}</TableText>
          </TableRow>
          <TableRow>
            <TableHeader>DC Degredation</TableHeader>
            <TableText>{`${reportData.dc_degrade} %`}</TableText>
          </TableRow>
          <TableRow>
            <TableHeader>Thermal Constant Loss</TableHeader>
            <TableText>{`${reportData.dc_thermal_Uc} W/m²k`}</TableText>
          </TableRow>
          <TableRow>
            <TableHeader>Thermal Wind Loss</TableHeader>
            <TableText>{`${reportData.dc_thermal_Uv} W/m²k/m/s`}</TableText>
          </TableRow>
          <TableRow>
            <TableHeader>Mod Quality Loss</TableHeader>
            <TableText>{`${reportData.dc_module_quality_loss} %`}</TableText>
          </TableRow>
          <TableRow>
            <TableHeader>Mod LID Loss</TableHeader>
            <TableText>{`${parseFloat(reportData.dc_module_lid_loss)?.toFixed(2)} %`}</TableText>
          </TableRow>
          <TableRow>
            <TableHeader>DC Module Mismatch</TableHeader>
            <TableText>{`${reportData.dc_module_mismatch} %`}</TableText>
          </TableRow>
          <TableRow>
            <TableHeader>DC Strings Mismatch</TableHeader>
            <TableText>{`${reportData.dc_strings_mismatch} %`}</TableText>
          </TableRow>
          <TableRow>
            <TableHeader>DC Wiring Loss @ STC</TableHeader>
            <TableText>{`${reportData.dc_wiring_loss_at_stc} %`}</TableText>
          </TableRow>
          <TableRow>
            <TableHeader>Bifacial Back Mismatch</TableHeader>
            <TableText>{`${reportData.bi_back_mismatch} %`}</TableText>
          </TableRow>
          <TableRow>
            <TableHeader>Auxiliaries</TableHeader>
            <TableText>{`${reportData.ac_aux_kw} kW`}</TableText>
          </TableRow>
          <TableRow>
            <TableHeader>AC Wiring Loss @ STC</TableHeader>
            <TableText>{`${reportData.ac_wiring_loss_at_stc} %`}</TableText>
          </TableRow>
          <TableRow>
            <TableHeader>Transformer Constant Loss</TableHeader>
            <TableText>{`${reportData.ac_transformer_loss_constant} %`}</TableText>
          </TableRow>
          <TableRow>
            <TableHeader>Transformer Loss @ STC</TableHeader>
            <TableText>{`${reportData.ac_transformer_loss_at_stc} %`}</TableText>
          </TableRow>
          <TableRow>
            <TableHeader>MV Line Loss @ STC</TableHeader>
            <TableText>{`${reportData.ac_MV_line_loss_stc} %`}</TableText>
          </TableRow>
          <TableRow>
            <TableHeader>Transmission Loss</TableHeader>
            <TableText>{`${reportData.ac_transmission_loss} %`}</TableText>
          </TableRow>
          <TableRow>
            <TableHeader>Other AC Losses</TableHeader>
            <TableText>{`${reportData.ac_other_loss} %`}</TableText>
          </TableRow>
        </Table>
      </View>
    </View>
  );
};

const SoilingAlbedoTable = ({ reportData }) => {
  return (
    <PerfTable>
      <PerfRow>
        <BlankCell>{``}</BlankCell>
        {months.map((month) => (
          <SoilingColHeader key={month}>{month}</SoilingColHeader>
        ))}
      </PerfRow>
      <PerfRow>
        <SoilingCellHeader>Soiling (%)</SoilingCellHeader>
        {reportData.soiling.map((soil, index) => (
          <SoilingCell key={index}>{soil}</SoilingCell>
        ))}
      </PerfRow>
      <PerfRow>
        <SoilingCellHeader>Albedo</SoilingCellHeader>
        {reportData.albedo.map((alb, index) => (
          <SoilingCell key={index}>{alb}</SoilingCell>
        ))}
      </PerfRow>
    </PerfTable>
  );
};

const PerfSummaryTable = ({ reportData }) => {
  // let { DHISums_kWhm2, EArray_MWh, EGrid_MWh, GHISums_kWhm2, GlobEff_kwhm2, GlobInc_kwhm2, PRratio, TAvg_C, WindAvg_ms } = reportData;
  // let temp_pr_object = { DHISums_kWhm2, EArray_MWh, EGrid_MWh, GHISums_kWhm2, GlobEff_kwhm2, GlobInc_kwhm2, PRratio, TAvg_C, WindAvg_ms };
  // let pr_object = JSON.parse(JSON.stringify(temp_pr_object));

  return (
    <PerfTable>
      <PerfRow>
        <PerfColSmall>
          <PerfCellHeader></PerfCellHeader>
        </PerfColSmall>
        <PerfCol>
          <PerfCellHeader>GHI (kWh/m²)</PerfCellHeader>
        </PerfCol>
        <PerfCol>
          <PerfCellHeader>DHI (kWh/m²)</PerfCellHeader>
        </PerfCol>
        <PerfCol>
          <PerfCellHeader>Temp (C°)</PerfCellHeader>
        </PerfCol>
        <PerfCol>
          <PerfCellHeader>Wind (m/s)</PerfCellHeader>
        </PerfCol>
        <PerfCol>
          <PerfCellHeader>Global Incident (kWh/m²)</PerfCellHeader>
        </PerfCol>
        <PerfCol>
          <PerfCellHeader>EArray (MWh)</PerfCellHeader>
        </PerfCol>
        <PerfCol>
          <PerfCellHeader>E_Grid (MWh)</PerfCellHeader>
        </PerfCol>
        <PerfCol>
          <PerfCellHeader>PR (%)</PerfCellHeader>
        </PerfCol>
      </PerfRow>
      {reportData.GHISums_kWhm2 &&
        reportData.GHISums_kWhm2.map((item, index) => (
          <PerfRow key={index}>
            <PerfColSmall>{index === 12 ? <PerfCell>YEAR</PerfCell> : <PerfCell>{months[index]}</PerfCell>}</PerfColSmall>
            <PerfCol>
              <PerfCell>{`${reportData.GHISums_kWhm2[index]}`}</PerfCell>
            </PerfCol>
            <PerfCol>
              <PerfCell>{`${reportData.DHISums_kWhm2[index]}`}</PerfCell>
            </PerfCol>
            <PerfCol>
              <PerfCell>{`${reportData.TAvg_C[index]}`}</PerfCell>
            </PerfCol>
            <PerfCol>
              <PerfCell>{`${reportData.WindAvg_ms[index]}`}</PerfCell>
            </PerfCol>
            <PerfCol>
              <PerfCell>{`${reportData.GlobInc_kwhm2[index]}`}</PerfCell>
            </PerfCol>
            <PerfCol>
              <PerfCell>{`${reportData.EArray_MWh[index]}`}</PerfCell>
            </PerfCol>
            <PerfCol>
              <PerfCell>{`${reportData.EGrid_MWh[index]}`}</PerfCell>
            </PerfCol>
            <PerfCol>
              <PerfCell>{`${parseFloat(reportData.PRratio[index])?.toFixed(2)}`}</PerfCell>
            </PerfCol>
          </PerfRow>
        ))}
    </PerfTable>
  );
};

// const LossesTable = ({ reportData }) => {
//   return (
//     <View style={Module_styles.module_section}>
//       <View style={Module_styles.perf_container}>
//         <Table>
//           <TableTitle title="Losses" />

//           {reportData.dc_degradation?.toFixed(2) != 0 && (
//             <TableRow>
//               <TableHeader>DC Degredation</TableHeader>
//               <TableText>{`${reportData.dc_degradation?.toFixed(2)} %`}</TableText>
//             </TableRow>
//           )}
//           {reportData.horizontal_global_irradiance?.toFixed(3) != 0 && (
//             <TableRow>
//               <TableHeader>Horiz. Global Irradiance</TableHeader>
//               <TableText>{`${reportData.horizontal_global_irradiance?.toFixed(3)} kWh/m²`}</TableText>
//             </TableRow>
//           )}
//           {reportData.global_incident_in_col_plane?.toFixed(5) != 0 && (
//             <TableRow>
//               <TableHeader>Global Incident in Col. Plane</TableHeader>
//               <TableText>{`${reportData.global_incident_in_col_plane?.toFixed(5)} %`}</TableText>
//             </TableRow>
//           )}
//           {reportData.near_shadings_irradiance_loss?.toFixed(5) != 0 && (
//             <TableRow>
//               <TableHeader>Near Shadings Irradiance Loss</TableHeader>
//               <TableText>{`${reportData.near_shadings_irradiance_loss?.toFixed(5)} %`}</TableText>
//             </TableRow>
//           )}
//           {reportData.iam_factor_on_global?.toFixed(6) != 0 && (
//             <TableRow>
//               <TableHeader>IAM Factor on Global</TableHeader>
//               <TableText>{`${reportData.iam_factor_on_global?.toFixed(6)} %`}</TableText>
//             </TableRow>
//           )}
//           {reportData.soiling_loss?.toFixed(6) != 0 && (
//             <TableRow>
//               <TableHeader>Soiling Loss</TableHeader>
//               <TableText>{`${reportData.soiling_loss?.toFixed(6)} %`}</TableText>
//             </TableRow>
//           )}
//           {reportData.bifacial_gain?.toFixed(6) != 0 && (
//             <TableRow>
//               <TableHeader>Bifacial Gain</TableHeader>
//               <TableText>{`${reportData.bifacial_gain?.toFixed(6)} %`}</TableText>
//             </TableRow>
//           )}
//           {reportData.global_effective_irradiation_on_col?.toFixed(3) != 0 && (
//             <TableRow>
//               <TableHeader>Glob. Eff. Irradiation on Col </TableHeader>
//               <TableText>{`${reportData.global_effective_irradiation_on_col?.toFixed(3)} kWh/m²`}</TableText>
//             </TableRow>
//           )}
//           {reportData.array_nominal_energy?.toFixed(0) != 0 && (
//             <TableRow>
//               <TableHeader>Array Nominal Energy</TableHeader>
//               <TableText>{`${reportData.array_nominal_energy?.toFixed(0)} kWh`}</TableText>
//             </TableRow>
//           )}
//           {reportData.pv_loss_irrad?.toFixed(6) != 0 && (
//             <TableRow>
//               <TableHeader>PV Loss Irrad</TableHeader>
//               <TableText>{`${reportData.pv_loss_irrad?.toFixed(6)} %`}</TableText>
//             </TableRow>
//           )}
//           {reportData.pv_loss_temp?.toFixed(6) != 0 && (
//             <TableRow>
//               <TableHeader>PV Loss Temp</TableHeader>
//               <TableText>{`${reportData.pv_loss_temp?.toFixed(6)} %`}</TableText>
//             </TableRow>
//           )}
//           {reportData.pv_elec_loss?.toFixed(0) != 0 && (
//             <TableRow>
//               <TableHeader>PV Elec Loss</TableHeader>
//               <TableText>{`${reportData.pv_elec_loss?.toFixed(0)} %`}</TableText>
//             </TableRow>
//           )}
//           {reportData.lid_loss?.toFixed(0) != 0 && (
//             <TableRow>
//               <TableHeader>LID Loss</TableHeader>
//               <TableText>{`${reportData.lid_loss?.toFixed(0)} %`}</TableText>
//             </TableRow>
//           )}
//           {reportData.quality_loss?.toFixed(1) != 0 && (
//             <TableRow>
//               <TableHeader>Quality Loss</TableHeader>
//               <TableText>{`${reportData.quality_loss?.toFixed(1)} %`}</TableText>
//             </TableRow>
//           )}
//           {reportData.dc_mismatch_loss?.toFixed(0) != 0 && (
//             <TableRow>
//               <TableHeader>DC Mismatch Loss</TableHeader>
//               <TableText>{`${reportData.dc_mismatch_loss?.toFixed(0)} %`}</TableText>
//             </TableRow>
//           )}
//           {reportData.ohmic_wiring_loss?.toFixed(6) != 0 && (
//             <TableRow>
//               <TableHeader>Ohmic Wiring Loss</TableHeader>
//               <TableText>{`${reportData.ohmic_wiring_loss?.toFixed(6)} %`}</TableText>
//             </TableRow>
//           )}
//           {reportData.e_array?.toFixed(0) != 0 && (
//             <TableRow>
//               <TableHeader>E Array</TableHeader>
//               <TableText>{`${reportData.e_array?.toFixed(0)} kWh`}</TableText>
//             </TableRow>
//           )}
//           {reportData.inverter_loss?.toFixed(0) != 0 && (
//             <TableRow>
//               <TableHeader>Inverter Loss</TableHeader>
//               <TableText>{`${reportData.inverter_loss?.toFixed(0)} %`}</TableText>
//             </TableRow>
//           )}
//           {reportData.ac_loss?.toFixed(1) != 0 && (
//             <TableRow>
//               <TableHeader>AC Loss</TableHeader>
//               <TableText>{`${reportData.ac_loss?.toFixed(1)} %`}</TableText>
//             </TableRow>
//           )}
//           {reportData.interconnect_lim_loss?.toFixed(0) != 0 && (
//             <TableRow>
//               <TableHeader>Interconnect Limit Loss</TableHeader>
//               <TableText>{`${reportData.interconnect_lim_loss?.toFixed(0)} %`}</TableText>
//             </TableRow>
//           )}
//         </Table>
//       </View>
//     </View>
//   );
// };
const calculateDCMaxPwr = (inv_pd_pacokw, maxEff) => {
  if (!isNaN(inv_pd_pacokw) && !isNaN(maxEff)) {
    if (inv_pd_pacokw > 0 && maxEff > 0) {
      return _.round((inv_pd_pacokw / maxEff) * 100, 2);
    }
  }
};

const InverterTable = ({ reportData }) => (
  <View style={Module_styles.module_section}>
    <Table>
      <TableTitle title="Inverter Inputs" />
      <TableRow>
        <TableHeader>Inverter Name</TableHeader>
        <TableText>{`${reportData.simple_inverter === 1 ? "Simple Inverter Input" : `${reportData.inv_name}`}`}</TableText>
      </TableRow>
      {reportData.simple_inverter === 1 ? (
        <>
          <TableRow>
            <TableHeader>{`DC:AC (ILR)`}</TableHeader>
            <TableText>{`${reportData.dcac}`}</TableText>
          </TableRow>
        </>
      ) : (
        <>
          <TableRow>
            <TableHeader>Inverter Rating</TableHeader>
            <TableText>{`${reportData.inv_rating} kW`}</TableText>
          </TableRow>
          <TableRow>
            <TableHeader>AC Power Nom</TableHeader>
            <TableText>{`${reportData.inv_pnom} kWac`}</TableText>
          </TableRow>
          <TableRow>
            <TableHeader>Min MPPT</TableHeader>
            <TableText>{`${reportData.mppt_low_inverter} V`}</TableText>
          </TableRow>
          <TableRow>
            <TableHeader>AC Power Max</TableHeader>
            <TableText>{`${reportData.inv_pd_pacokw} kWac`}</TableText>
          </TableRow>
          <TableRow>
            <TableHeader>Max MPPT</TableHeader>
            <TableText>{`${reportData.mppt_hi_inverter} V`}</TableText>
          </TableRow>
          <TableRow>
            <TableHeader>Max Efficiency</TableHeader>
            <TableText>{`${reportData.maxEff} %`}</TableText>
          </TableRow>
          <TableRow>
            <TableHeader>Max PV Volts</TableHeader>
            <TableText>{`${reportData.inv_pd_vdcmax} V`}</TableText>
          </TableRow>
          <TableRow>
            <TableHeader>DC at Max Pwr</TableHeader>
            <TableText>{`${calculateDCMaxPwr(reportData.inv_pd_pacokw, reportData.maxEff)} kW`}</TableText>
          </TableRow>
          <TableRow>
            <TableHeader>Night Pwr Use</TableHeader>
            <TableText>{`${reportData.inv_pd_pnt} W`}</TableText>
          </TableRow>
        </>
      )}
    </Table>
  </View>
);

const LayoutTable = ({ reportData }) => {
  return (
    <View style={Module_styles.module_section}>
      <Table>
        <TableTitle title="Layout Inputs" />
        <TableRow>
          <TableHeader>GCR</TableHeader>
          <TableText>{`${parseFloat(reportData.gcr)?.toFixed(2)}`}</TableText>
        </TableRow>
        <TableRow>
          <TableHeader>Azimuth</TableHeader>
          <TableText>{`${reportData.sazm}°`}</TableText>
        </TableRow>
        <TableRow>
          <TableHeader>Pitch</TableHeader>
          <TableText>{`${reportData.pitch} m`}</TableText>
        </TableRow>
        <TableRow>
          <TableHeader>Intrarow Spacing</TableHeader>
          <TableText>{`${+reportData.r2r?.toFixed(2)} m`}</TableText>
        </TableRow>
        <TableRow>
          <TableHeader>Buildable Area</TableHeader>
          <TableText>{`${reportData.boundary_area?.toFixed(2)} ha`}</TableText>
        </TableRow>
        <TableRow>
          <TableHeader>Racking Footprint (Acres)</TableHeader>
          <TableText>{`${reportData?.footprint?.toFixed(2)} acres`}</TableText>
        </TableRow>
        <TableRow>
          <TableHeader>Racks Removed based on Grade</TableHeader>
          <TableText>{reportData.topo_layout_action === "delete" ? `On` : `Off`}</TableText>
        </TableRow>

        <TableRow>
          <TableHeader>Coordinate System</TableHeader>
          <TableText>{`WGS 84`}</TableText>
        </TableRow>
        {/* <TableRow>
          <TableHeader>Wiring</TableHeader>
          <TableText>{reportData.do_wiring == 1 ? `On` : `Off`}</TableText>
        </TableRow> */}
        {reportData.do_wiring === 1 && (
          <>
            <TableRow>
              <TableHeader>Combiner Location</TableHeader>
              <TableText>{`${reportData.combiner_location === 0 ? "Centroids" : "By Road"}`}</TableText>
            </TableRow>
            <TableRow>
              <TableHeader>Strings per Combiner</TableHeader>
              <TableText>{`${reportData.strings_per_combiner}`}</TableText>
            </TableRow>
          </>
        )}
      </Table>
    </View>
  );
};

const BOMTable = ({ reportData }) => {
  return (
    <Table>
      <TableTitle title="BOM Table" />
      <TableRow>
        <TableHeader>Rack A Qty</TableHeader>
        <TableText>{`${reportData.rack_breakdown[0]}`}</TableText>
      </TableRow>
      <TableRow>
        <TableHeader>Rack B Qty</TableHeader>
        <TableText>{`${reportData.rack_breakdown[1]}`}</TableText>
      </TableRow>
      <TableRow>
        <TableHeader>Rack C Qty</TableHeader>
        <TableText>{`${reportData.rack_breakdown[2]}`}</TableText>
      </TableRow>
      <TableRow>
        <TableHeader>Module Qty</TableHeader>
        <TableText>{`${reportData.en_mod_target === 1 ? parseInt(reportData.mod_target) : parseInt(reportData.module_count)}`}</TableText>
      </TableRow>
      <TableRow>
        <TableHeader>Inverter Quantity</TableHeader>
        <TableText>{`${reportData.simple_inverter === 1 ? "Simple Inverter Input" : `${reportData.inverter_qty}`}`}</TableText>
      </TableRow>
      {/* TODO: Combiner Boxes Qty "n/a" if wiring is off. Otherwise value from wiring
          DC Wiring "n/a" if wiring is off, otherwise value from wiring. Unit: "ft." integer is fine. */}
      {/* <TableRow>
        <TableHeader>Combiner Boxes Qty</TableHeader>
        <TableText>{reportData.do_wiring == 1 ? `${reportData.combiner_count}` : `n/a`}</TableText>
      </TableRow>
      <TableRow>
        <TableHeader>DC Wiring</TableHeader>
        <TableText>{reportData.do_wiring == 1 ? `${parseInt(reportData.wire_length_ft)} ft` : `n/a`}</TableText>
      </TableRow> */}
    </Table>
  );
};

const FakeLossData = {
  ghi: {
    "Horizontal global irradiation (kWh/m²)": { value: 1368.1, poi: true },
    "Global incident in coll. plane %": { value: 1813.4, change: 32.4 },
    "Near Shadings: irradiance loss": { value: 1743.9, change: -3.74 },
    "IAM factor on global": { value: 1719.1, change: -1.36 },
    "Soiling loss factor": { value: 1684.8, change: -2.0 },
    "Ground reflection on front side": { value: 1696.3, change: 0.73 },
    "Effective irradiation on collectors": { value: 1696.3, change: 0, poi: true, area: 22465.2 },
    "Area of collectors (m²)": { value: 22465.2, change: 0 },
    "Efficiency at STC (%)": { value: 0.2, change: 18.45 },
    "Array nominal energy at STC (MWh)": { value: 7674.3, change: 0, poi: true },
    "Loss due to irradiance level": { value: 7612.7, change: -0.79 },
    "PV loss due to temperature": { value: 7437.5, change: -1.7 },
    // "Shadings: Electrical loss": { value: 7437.5, change: 0 },
    // "Spectral correction": { value: 7437.5, change: 0 },
    "Module quality loss": { value: 7511.9, change: 1 },
    "LID - Light induced degradation": { value: 7399.2, change: -1.5 },
    "Mismatch loss, modules and strings": { value: 7317.8, change: -1.1 },
    "Mismatch for back irradiance": { value: 7238.5, change: -1.18 },
    "Ohmic wiring loss": { value: 7162.6, change: -1.09 },
    "Array virual energy at MPP (MWh)": { value: 7162.6, change: 0, poi: true },
    "Inverter Loss during operation (efficiency)": { value: 6987.3, change: -2.43 },
    "Inverter Loss over nominal inv. power": { value: 6928.7, change: -0.86 },
    "Inverter Loss due to max input current": { value: 6928.7, change: 0 },
    "Inverter Loss over nominal inv. voltage": { value: 6928.7, change: 0 },
    "Inverter loss due to power threshold": { value: 6928.6, change: 0 },
    "Inverter loss due to voltage threshold": { value: 6928.6, change: 0 },
    "Night consumption": { value: 6891.1, change: -0.54 },
    "Available Energy at Inverter Output (MWh)": { value: 6891.1, change: 0, poi: true },
    "Auxiliaries (fans, other)": { value: 6679.6, change: -3.0 },
    "AC ohmic loss": { value: 6629.6, change: -0.78 },
    "MV transformer loss": { value: 6550.2, change: -1.24 },
    "MV line ohmic losss": { value: 6501.9, change: -0.8 },
    // "Fixed Transmission Loss": { value: 6501.9, change: 0 },
    // "AC Other": { value: 6501.9, change: 0 },
    // "Unused energy (grid limitation)": { value: 6501.9, change: 0 },
    "Energy injected into Grid (MWh)": { value: 6502.1, poi: true },
  },
  bifacial: {
    "Global incidence on ground": { value: 748.4, change: 0, poi: true },
    "Global incidence on ground on area": { value: 64186.3, change: 0 },
    "Ground reflection loss (Albedo)": { value: 224.5, change: -70 },
    "View Factor for rear side": { value: 61.6, change: -72.56 },
    "sky diffuse on the rear side": { value: 78.4, change: 20.69 },
    "Beam effective on the rear side": { value: 0, change: 0 },
    "Shadings loss on rear side": { value: 0, change: 0 },
    "Global irradiance on rear side": { value: 220, change: 12.98, poi: true },
    "PV conversion, Bifaciality factor": { value: 0.75, change: 0.75 },
    // "Effective irradiation on collectors rear (kWh/m²)": { value: 206.2, change: 0, poi: true },
    // "Effective irradiation on collectors rear * bifaciality (kWh/m²)": { value: 154.6, change: 0 },
  },
};

const LossTableText = StyleSheet.create({
  center: {
    width: "100%",
    textAlign: "center",
  },
});

const LossTable = ({ reportData, bifacial = false }) => {
  // console.log("reportData", reportData);
  return (
    <>
      {bifacial ? (
        <BifacialLossTableBox>
          <BifacialHeader key="bifacial_header">Bifacial</BifacialHeader>
          {Object.keys(reportData.loss_stack.bifacial).map((key) => {
            if (key !== "Global incidence on ground on area" && (reportData.loss_stack.bifacial[key].value || reportData.loss_stack.bifacial[key].change)) {
              if (key === "Global incidence on ground") {
                return (
                  <LossTableTwoRow key={key}>
                    <Text>{key}</Text>
                    <Text>{`${reportData.loss_stack.bifacial[key].value} kWh/m² on ${reportData.loss_stack.bifacial["Global incidence on ground on area"].value} m² `}</Text>
                  </LossTableTwoRow>
                );
              } else if (key === "Global irradiance on rear side") {
                return (
                  <LossTableBifacialColSpan key={key}>
                    <Text style={LossTableText.center}>{`${reportData.loss_stack.bifacial[key].change}% ${key} (${reportData.loss_stack.bifacial[key].value} kWh/m²) `}</Text>
                  </LossTableBifacialColSpan>
                );
              } else if (key === "PV conversion, Bifaciality factor") {
                return (
                  <BifacialSpacingRow key={key}>
                    <Text style={LossTableText.center}>{`${key} = ${reportData.loss_stack.bifacial[key].value}`}</Text>
                  </BifacialSpacingRow>
                );
              } else if (reportData.loss_stack.bifacial[key].poi) {
                return (
                  <LossTableRow key={key}>
                    <LossTableHeader>{key}</LossTableHeader>
                    <LossTableHeaderSmall>{reportData.loss_stack.bifacial[key].value}</LossTableHeaderSmall>
                  </LossTableRow>
                );
              } else {
                return (
                  <LossTableRow key={key}>
                    <LossTableCell>{key}</LossTableCell>
                    <LossTableCellSmall>
                      {reportData.loss_stack.bifacial[key].change ? `${reportData.loss_stack.bifacial[key].change} %` : reportData.loss_stack.bifacial[key].change === 0 ? `${0}%` : ""}
                    </LossTableCellSmall>
                  </LossTableRow>
                );
              }
            }
          })}
          {reportData.en_bifacial === 1 && reportData.bi_bifaciality && (
            <LossTableSpacingRow_no_border key="bifaciality">
              <Text style={LossTableText.center}>{`Bifaciality Factor = ${reportData.bi_bifaciality}`}</Text>
            </LossTableSpacingRow_no_border>
          )}
        </BifacialLossTableBox>
      ) : (
        <LossTableBox>
          {Object.keys(reportData.loss_stack.ghi).map((key) => {
            if (key !== "Area of collectors (m^2)" && (reportData.loss_stack.ghi[key].value || reportData.loss_stack.ghi[key].change)) {
              if (key === "Horizontal global irradiation (kWh/m²)") {
                return (
                  <LossTableRow key={key}>
                    <LossTableHeader>{key}</LossTableHeader>
                    <LossTableHeaderSmall>{`${reportData.loss_stack.ghi[key].value}`}</LossTableHeaderSmall>
                  </LossTableRow>
                );
              } else if (key === "Effective irradiation on collectors (kWh/m^2)") {
                return (
                  <LossTableTwoRow key={key}>
                    <Text>{"Effective irradiation on collectors"}</Text>
                    <Text> {`${reportData.loss_stack.ghi[key].value} kWh/m² * ${reportData.loss_stack.ghi["Area of collectors (m^2)"].value} m² coll. `}</Text>
                  </LossTableTwoRow>
                );
              } else if (key === "Efficiency at STC (%)") {
                return (
                  <LossTableSpacingRow key={key}>
                    <Text style={LossTableText.center}>{`${key} = ${reportData.loss_stack.ghi[key].change}%`}</Text>
                  </LossTableSpacingRow>
                );
              } else if (key === "Yield (kWh/kWp)") {
                return (
                  <LossTableRow key={key}>
                    <LossTableCell>{key}</LossTableCell>
                    <LossTableCellSmall>{`${reportData.loss_stack.ghi[key].value}`}</LossTableCellSmall>
                  </LossTableRow>
                );
              } else if (key === "Array virual energy at MPP") {
                return (
                  <LossTableRow key={key}>
                    <LossTableHeader>{`${key} (MWh)`}</LossTableHeader>
                    <LossTableHeaderSmall>{reportData.loss_stack.ghi[key].value}</LossTableHeaderSmall>
                  </LossTableRow>
                );
              } else if (reportData.loss_stack.ghi[key].poi) {
                return (
                  <LossTableRow key={key}>
                    <LossTableHeader>{key}</LossTableHeader>
                    <LossTableHeaderSmall>{reportData.loss_stack.ghi[key].value}</LossTableHeaderSmall>
                  </LossTableRow>
                );
              } else {
                return (
                  <LossTableRow key={key}>
                    <LossTableCell>{removePercent(key)}</LossTableCell>
                    <LossTableCellSmall>
                      {reportData.loss_stack.ghi[key].change ? `${reportData.loss_stack.ghi[key].change} %` : reportData.loss_stack.ghi[key].change === 0 ? `${0}%` : ""}
                    </LossTableCellSmall>
                  </LossTableRow>
                );
              }
            }
          })}
        </LossTableBox>
      )}
    </>
  );
};

const TopoLossTable = ({ topo_impact }) => {
  console.log("topo_impact", topo_impact);
  return (
    <BifacialLossTableBox>
      <BifacialHeader key="topo_impact_header">Topo Impact</BifacialHeader>
      {Object.values(topo_impact.value).map((item) => {
        return (
          <LossTableRow key={item.label}>
            <LossTableCell>{removePercent(item.label)}</LossTableCell>
            <LossTableCellSmall> {`${item.value} %`}</LossTableCellSmall>
          </LossTableRow>
        );
      })}
    </BifacialLossTableBox>
  );
};

export { Tracker_Breakdown, ModuleSection, Racking, Performance, PerfSummaryTable, Rundown, IAMTable_report, InverterTable, LayoutTable, BOMTable, SoilingAlbedoTable, LossTable, TopoLossTable };
